export default {
	title: "Guias Espirituais",
	activeGuidesCount: "Guias Ativos",
	totalGuidesCount: "Total de Guias",
	withMediumsCount: "Com Médiuns",
	noGuidesFound: "Nenhum guia encontrado",
	errorLoadingGuides: "Erro ao carregar guias",
	errorLoadingAvailableGuides: "Erro ao carregar guias disponíveis",
	guideAddedSuccess: "Guia adicionado com sucesso",
	guideUpdatedSuccess: "Guia atualizado com sucesso",
	guideDeactivatedSuccess: "Guia desativado com sucesso",
	guideActivatedSuccess: "Guia ativado com sucesso",
	guideRemovedSuccess: "Guia removido com sucesso",
	errorSavingGuide: "Erro ao salvar guia",
	errorDeactivatingGuide: "Erro ao desativar guia",
	errorActivatingGuide: "Erro ao ativar guia",
	errorRemovingGuide: "Erro ao remover guia",
	confirmRemoveGuide: "Tem certeza que deseja remover este guia?",
	guide: "Guia",
	spiritualLine: "Linha Espiritual",
	search: "Buscar guias...",
	edit: "Editar Guia",
	create: "Criar Guia",
	deleteConfirmation: "Deseja realmente excluir o guia {name}?",
	deactivate: "Inativar",
	deactivateConfirmation: "Deseja inativar o guia {name}? Ele deixará de aparecer nas listagens, mas poderá ser reativado depois.",
	deletePermanent: "Excluir permanentemente",
	deletePermanentConfirmation: "Deseja excluir permanentemente o guia {name}? Esta ação não pode ser desfeita.",
	deletePermanentWarning: "A exclusão permanente só é possível se o guia não tiver nenhum vínculo (médiuns, atendimentos, tickets ou retornos). Caso contrário, use a opção Inativar.",
	createSuccess: "Guia criado com sucesso!",
	createError: "Erro ao criar guia",
	primaryMedium: "Médium Principal",
	primaryGuide: "Guia Principal",
	setPrimary: "Definir como Principal",
	primarySetSuccess: "Médium principal definido com sucesso",
	primaryWillReplaceExisting: "Ao marcar como principal, o médium/guia principal anterior na mesma linha espiritual será desmarcado automaticamente.",
	errorSettingPrimary: "Erro ao definir médium principal",
	form: {
		nameLabel: "Nome do Guia",
		nameHint: "Digite o nome do guia",
		spiritualLineLabel: "Linha Espiritual",
		spiritualLineHint: "Selecione a linha espiritual",
		personLabel: "Pessoa (Opcional)",
		personHint: "Selecione uma pessoa associada ao guia",
		primaryMediumLabel: "Médium Principal",
		willBePrimaryMedium: "Será definido como médium principal deste guia",
		isPrimaryLabel: "Médium principal",
		descriptionLabel: "Descrição",
		descriptionHint: "Descrição sobre o guia",
		isActiveLabel: "Guia ativo",
		associatedPersonHint: "Esta pessoa já está associada ao guia e não pode ser alterada",
		associatedPersonTooltip: "Para alterar a pessoa associada, use o gerenciamento de pessoas do guia",
		personSearchPlaceholder: "Digite para buscar uma pessoa...",
		noPersonFound: "Nenhuma pessoa encontrada",
	},
	filter: {
		all: "Todos",
		active: "Ativos",
		inactive: "Inativos",
	},
	validation: {
		nameRequired: "Nome é obrigatório",
		nameMaxLength: "Nome deve ter no máximo 100 caracteres",
		spiritualLineRequired: "Linha espiritual é obrigatória",
		descriptionMaxLength: "Descrição deve ter no máximo 500 caracteres",
	},
	tabs: {
		overview: "Visão Geral",
		persons: "Pessoas",
	},
	details: {
		basicInfo: "Informações Básicas",
		noPeopleAssociated: "Nenhuma pessoa associada a este guia",
		totalPeople: "Total de Pessoas",
		activePeople: "Pessoas Ativas",
		totalConsultations: "Consultas",
	},
	messages: {
		loading: "Carregando guia...",
		created: "Guia {name} criado com sucesso",
		updated: "Guia {name} atualizado com sucesso",
		deleted: "Guia {name} excluído com sucesso",
		deactivated: "Guia {name} inativado com sucesso",
		deletedPermanent: "Guia {name} excluído permanentemente",
		createError: "Erro ao criar guia",
		updateError: "Erro ao atualizar guia",
		deleteError: "Erro ao excluir guia",
		deactivateError: "Erro ao inativar guia",
		deletePermanentError: "Erro ao excluir guia permanentemente",
	},
	errors: {
		invalidId: "ID do guia inválido",
		fetchError: "Erro ao carregar dados do guia",
	},
	empty: {
		title: "Nenhum guia espiritual encontrado",
		description: "Cadastre os guias espirituais que atuam no terreiro",
	},
};
